export var Engine;
(function (Engine) {
    /** 企业接入类型 */
    let EntryType;
    (function (EntryType) {
        /** 氚云自有流量接入 */
        EntryType["H3"] = "H3";
        /** 钉钉ISV接入 */
        EntryType["DingTalk"] = "DingTalk";
        /** 钉钉企业接入 */
        EntryType["DingTalkCorp"] = "DingTalkCorp";
        /** 微信接入 */
        EntryType["WeChat"] = "WeChat";
        EntryType["WeChatDK"] = "WeChatDK";
        /** 企微ISV接入 */
        EntryType["WeChatISV"] = "WeChatISV";
        /** 飞书接入 */
        EntryType["FeiShuCorp"] = "FeiShuCorp";
        EntryType["FeiShuISV"] = "FeiShuISV";
    })(EntryType = Engine.EntryType || (Engine.EntryType = {}));
    /** 企业接入类型文本 */
    Engine.EntryTypeText = {
        [EntryType.H3]: '自有企业',
        [EntryType.DingTalk]: '钉钉',
        [EntryType.DingTalkCorp]: '钉钉',
        [EntryType.WeChat]: '企业微信',
        [EntryType.WeChatDK]: '企业微信',
        [EntryType.WeChatISV]: '企业微信',
        [EntryType.FeiShuCorp]: '飞书',
        [EntryType.FeiShuISV]: '飞书',
    };
    /** 企业类型，后续取消 */
    let EngineType;
    (function (EngineType) {
        EngineType["SaasDevelopment"] = "SaaSDevelopment";
        EngineType["Product"] = "Product";
        EngineType["PrivateDevelopment"] = "PrivateDevelopment";
    })(EngineType = Engine.EngineType || (Engine.EngineType = {}));
    /** 企业信息详情 */
    class EngineInfo {
        /** 引擎编码 */
        engineCode = null;
        /** 引擎名称 */
        engineName = null;
        /** 开发者编码 */
        devCode = null;
        /** 公司ID(用于获取组织树) */
        companyId = null;
        /** 企业编码 */
        entryCorpId = null;
        /** 是否开发者企业 */
        get isDeveloper() {
            if (!this.devCode || !/[^\s]/.test(this.devCode)) {
                return false;
            }
            else {
                // 不为空
                return true;
            }
        }
        /** 企业接入类型 */
        entryType = null;
        /** 企业引擎类型 */
        engineType = null;
        /** 企业logo*/
        logoUrl = null;
        /** 当前企业的许可信息 */
        license = undefined;
        createdTime = null;
        suiteKey;
        agentId;
        /** 当前企业许可编码 */
        licenseCode = undefined;
    }
    Engine.EngineInfo = EngineInfo;
})(Engine || (Engine = {}));
